import React from 'react'
import QuestionLayout from './QuestionLayout.js'
import QuestionMenu from './QuestionMenu.js'
import Menu from './Menu.js'
import './SurveyPage.css'

const SurveyPage = () => {
  return (
    <div className="main">
      <Menu />
      <QuestionMenu />
      <QuestionLayout />
    </div>
  )
}

export default SurveyPage



// WEBPACK FOOTER //
// ./src/components/SurveyPage.js